export const setTitle = (title: string) => (document.title = title);

const setTitleFromLoader = (title: string) => () => {
  setTitle(title);
  return null;
};

export default setTitleFromLoader;
